/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ShiftElementDirections {
    MoveRight,
    MoveLeft,
    MoveRightEnd,
    MoveLeftEnd
  }